
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13413',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13413",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1019",
  "client-types": "static-1.505",
  "data-fetching-client": "static-1.10059",
  "foundations-components": "static-1.8655",
  "foundations-components-legacy": "static-1.1680",
  "foundations-theming": "static-1.4895",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.92",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8452",
  "hub-http-shared-msw-handlers": "static-1.10802",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11904",
  "I18n": "static-7.1691",
  "jasmine-runner": "static-1.6861",
  "marketplace-discovery-studio-lib": "static-1.810",
  "marketplace-storefront-base": "static-1.13476",
  "quartz": "static-1.7587",
  "react-dlb": "static-1.92",
  "react-rhumb": "static-1-fix-undefined-routespec-crash.10",
  "reactive-variable-buffer-atom": "static-1.3266",
  "reporting-testing-lib": "static-1.11109",
  "reselect": "static-3.15",
  "settings-ui-lib": "static-1.12942",
  "SharedI18nStrings": "static-1.186",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7767",
  "ui-addon-i18n": "static-1.11560",
  "ui-addon-react-router-dom": "static-1.9943",
  "unified-auth": "static-1.1131",
  "unified-auth-core-lib": "static-1.1413",
  "usage-tracker": "static-1.7727",
  "usage-tracker-core": "static-1.7577",
  "customer-data-property-utils": "static-1.8464",
  "hub-http": "static-1.6623",
  "integrations-lib": "static-1.17295",
  "marketplace-ui-common": "static-1.20952",
  "marketplace-ui-install": "static-1.938",
  "property-management-iframe": "static-1.14345",
  "quartz-config": "static-1.1365",
  "quartz-core": "static-1.6806",
  "quartz-routing": "static-1.1017",
  "quick-fetch": "static-1.4191",
  "react": "static-7.202",
  "rpc-client-utils": "static-1.5082",
  "ts-schema": "static-1.4360",
  "ui-universal-auth": "static-1.9617",
  "UIComponents": "static-3.8850",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3864",
  "quartz-webpack": "static-1.3811",
  "bend-plugin-quartz-routing": "static-1.665",
  "ai-components-ui-library": "static-1.9920",
  "codemirror": "static-5.105",
  "foundations-assets": "static-1.5300",
  "pulse": "static-1.1052",
  "react-codemirror": "static-1.11053",
  "ui-extensions-preview-lib": "static-1.818",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4924",
  "floating-ui": "static-1.67",
  "foundations-theming-specialty": "static-1.2611",
  "framer-motion": "static-1.83",
  "hs-story-utils": "static-1.9839",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.88",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5622",
  "react-virtualized": "static-2.111",
  "StyleGuideUI": "static-3.512",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2941",
  "ui-fonts": "static-1.1166",
  "ui-images": "static-2.1269",
  "bend-plugin-foundations-theming": "static-1.3378",
  "foundations-theming-base": "static-1.3880",
  "stylex": "static-1.45",
  "HeadJS": "static-2.811",
  "hs-test-utils-bend-plugin": "static-1.3563",
  "msw": "static-1.39",
  "msw-config": "static-1.17",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4722",
  "ui-addon-video-player": "static-1.9057",
  "ai-rendering-library": "static-1.11300",
  "chirp-fetch": "static-1.2313",
  "connections-embed-lib": "static-1.1661",
  "copilot-toolkit": "static-1.12041",
  "feedback-loader": "static-1.29972",
  "laboratory-lib": "static-3.7564",
  "marketplace-embed": "static-1.23099",
  "marketplace-ui-details": "static-1.10847",
  "marketplace-ui-reviews": "static-1.20907",
  "marketplace-ui-tracking": "static-1.15122",
  "sanitize-text": "static-1.8571",
  "usage-tracker-multi": "static-1.6141",
  "usage-tracker-session-replay": "static-1.5413",
  "wootric-nps": "static-1.7263",
  "quartz-head": "static-1.1252",
  "web-vitals": "static-1.18",
  "apollo-link-hub-http": "static-2.5019",
  "immer": "static-1.104",
  "immerable": "static-1.4556",
  "highcharts": "static-8.114",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2778",
  "reporting-data": "static-1.69176",
  "cssUtils": "static-1.1034",
  "flux-actions": "static-1.378",
  "react-colorpicker": "static-2.10626",
  "react-dnd-compat": "static-1.5025",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10784",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7717",
  "icons": "static-2.699",
  "marketplace-ui-apps-core": "static-1.19484",
  "storybook-react": "static-1.43",
  "trellis-story-utils": "static-1.4921",
  "foundations-components-test-utils": "static-1.6138",
  "quartz-i18n": "static-1.1262",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.661",
  "ads-unified-auth-lib": "static-1.1759",
  "custom-vendor-connection-lib": "static-1.181",
  "google-sheets-integration-lib": "static-1.1226",
  "microsoft-drive-auth-lib": "static-1.389",
  "surveymonkey-integration-lib": "static-1.758",
  "slack-ui-library": "static-1.10811",
  "fsm": "static-1.4167",
  "customer-data-objects": "static-1.8106",
  "property-translator": "static-1.5794",
  "hs-locale-management": "static-1.361",
  "frontend-preferences-client": "static-1.8332",
  "hs-promise-utils": "static-1.6003",
  "hubspot-apollo-client": "static-1.5288",
  "integrations-error-boundary-lib": "static-1.14711",
  "integrations-tracking-lib": "static-1.6024",
  "native-integrations-shared-strings": "static-1.8176",
  "sanitize": "static-1.4885",
  "superstore": "static-1.5172",
  "ui-shepherd-react": "static-3.10687",
  "ai-settings-ui-library": "static-1.8488",
  "hub-http-janus": "static-1.896",
  "hubspotter-http": "static-1.4927",
  "immutable-less": "static-1.5064",
  "marketplace-ui-client-types": "static-1.18359",
  "nav-meta": "static-1.30692",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18508",
  "ui-product-approvals-common": "static-1.1421",
  "ai-studio-lib": "static-1.12642",
  "hubspot-prosemirror": "static-1.19175",
  "integrations-reconnect-lib": "static-1.634",
  "ui-addon-iframeable": "static-1.9492",
  "ui-addon-integrations-directory-panel": "static-2.8388",
  "ui-product-approvals": "static-1.29526",
  "ui-tool-access": "static-1.10569",
  "inbound-db-properties-service-client": "static-1.4109",
  "property-management-common": "static-1.6633",
  "opentelemetry-fe-types": "static-1-aeastham-default-document-load-user-interaction.4",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.593",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1-aeastham-default-document-load-user-interaction.4",
  "quartz-auth": "static-1.1262",
  "quartz-test": "static-1.1262",
  "quartz-tracking": "static-1.966",
  "trellis-components": "static-1.2960",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.492",
  "HubStyle": "static-2.12211",
  "bender-build-tools": "static-1.3513",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.114",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23493",
  "ContentUtils": "static-1.69339",
  "customer-data-objects-ui-components": "static-1.13443",
  "sassPrefix": "static-1.302",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.555",
  "batch-promise": "static-1.1959",
  "event-emitter": "static-1.1373",
  "fast-json-patch": "static-1.73",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5850",
  "magpie-types": "static-1.5310",
  "stylex-utils": "static-1.158",
  "trellis-theming": "static-1.1394",
  "avatar-components": "static-1.2897",
  "breeze-engine-core": "static-1.1281",
  "breeze-onboarding-components": "static-1.952",
  "customer-data-filters-ui": "static-1.41211",
  "customer-data-reference-ui-components": "static-1.13580",
  "data-integrations-breeze": "static-1.180",
  "embedded-academy-lib": "static-1.15830",
  "ExportDialog": "static-6.10787",
  "global-styles-ai-lib": "static-1.377",
  "highlight.js": "static-1.89",
  "marketplace-embed-ba": "static-1.802",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42259",
  "reporting-snowflake": "static-1.57792",
  "reporting-ui-components": "static-2.66445",
  "reporting-visualizations": "static-1.61250",
  "trial-components-library": "static-1.14293",
  "ui-addon-teams": "static-1.21968",
  "upgrade-components-lib": "static-1.650",
  "navigation-components": "static-1.19055",
  "breeze-engine-lib": "static-1.2003",
  "simple-logging-lib": "static-1.3466",
  "nudge-client-utils": "static-1.3313",
  "fail-safe": "static-1.366",
  "app-governance-lib": "static-1.2581",
  "developer-experience-shared-components": "static-1.10951",
  "purchase-motions-components": "static-1.6557",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10622",
  "usage-tracker-anonymous": "static-1.6144",
  "usage-tracker-public": "static-1.7538",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3741",
  "persist-promise": "static-1.4116",
  "reference-resolvers": "static-1.8594",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4330",
  "hubspot-apollo-cache": "static-1.747",
  "universal-page-editor-lib": "static-1.3424",
  "final-form": "static-1.82",
  "redux-toolkit": "static-1.81",
  "simple-data-table": "static-1.3719",
  "merchandise-lib": "static-1.283",
  "onboarding-scopes": "static-1.6865",
  "ui-addon-draggable": "static-3.5159",
  "content-assistance-lib": "static-1.8340",
  "content-media-capture": "static-1.5668",
  "customer-data-ui-utilities": "static-1.10245",
  "emoji-mart": "static-3.6",
  "file-manager-components": "static-1.24737",
  "growth-payments-core": "static-1.26392",
  "knowledge-content-types": "static-1.8699",
  "PatternValidationJS": "static-1.3301",
  "payment-link-components": "static-1.24332",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20467",
  "ui-addon-emoji-picker": "static-1.10281",
  "ui-business-units-lib": "static-1.9508",
  "video-components-external": "static-1.12326",
  "video-data-lib": "static-1.35984",
  "navigation-messaging": "static-1.8382",
  "collaboration-sidebar": "static-1.58939",
  "trellis-ext-dnd": "static-1.453",
  "crm-component-utils": "static-1.40054",
  "crm-properties-common-lib": "static-1.6302",
  "customer-data-properties": "static-1.52877",
  "external-options-client-types": "static-1.4408",
  "framework-data-schema-resolvers": "static-1.7309",
  "property-value-citations": "static-1.3491",
  "reference-resolvers-lite": "static-1.8519",
  "hubspotter-http-shared-msw-handlers": "static-1.10800",
  "base-ui": "static-1.26",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "cms-field-types": "static-1.5226",
  "content-icons-ui": "static-1.2417",
  "atom": "static-1.5491",
  "idb-keyval": "static-1.54",
  "reactive-lib": "static-1.1136",
  "breeze-artifacts-sdk": "static-1.672",
  "getting-started-shared-tasks": "static-1.19459",
  "onboarding-journeys-lib": "static-1.1138",
  "conversations-skeleton-state": "static-1.7602",
  "crm-message-bus": "static-1.43987",
  "customer-data-filters-ui-msw-helpers": "static-1.23646",
  "events-data-lib": "static-1.661",
  "FormUrlGenerator": "static-2.5126",
  "framework-builder-read-service-client": "static-1.4289",
  "hs-resources": "static-1.608",
  "multi-account-reference-resolvers": "static-1.1417",
  "onboarding-tours": "static-1.17304",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14665",
  "segments-client-types": "static-1.11959",
  "academy-common-lib": "static-1.15290",
  "dashboard-lib": "static-1.83159",
  "hubspot-prosemirror-plugins": "static-1.19167",
  "share-with-third-party-component-lib": "static-1.9124",
  "ui-asset-management-lib": "static-1.11516",
  "user-context": "static-1.5477",
  "reporting-plugins": "static-1.10904",
  "reporting-reports": "static-1.68852",
  "hubs-service-types": "static-1.1677",
  "purchase-motions-api": "static-1.6560",
  "salesImages": "static-1.672",
  "signup-constants": "static-1.19835",
  "nest": "static-1.649",
  "breeze-engine-chat-components": "static-1.981",
  "ably": "static-2.2",
  "nudge-custom-function-registry": "static-1.3070",
  "nudge-renderer-utils": "static-1.3389",
  "whisper-core-api": "static-1.7531",
  "bend-plugin-fail-safe": "static-1.317",
  "framework-listing-lib": "static-2.29702",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31643",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "signup-ui-url-generator": "static-2.8473",
  "onboarding-tours-client": "static-1.5519",
  "one-click-checkout": "static-1.645",
  "platform-infra-nav-components": "static-1.7964",
  "subscription-experience-data-types": "static-1.15363",
  "crm-record-cards-service-types": "static-1.3834",
  "location-customization-utils-lib": "static-1.10314",
  "redux-thunk": "static-2.83",
  "react-flip-move": "static-1.82",
  "ui-coaching-tips": "static-1.29503",
  "content-media-composition-data-lib": "static-1.13472",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4839",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3886",
  "seat-types-lib": "static-1.937",
  "ui-addon-opt": "static-4.8794",
  "commerce-tours-lib": "static-1.6778",
  "growth-onboarding-reliability": "static-1.5496",
  "sales-checkout-service-client": "static-1.3943",
  "data-token-picker": "static-1.17042",
  "FileManagerLib": "static-1.40377",
  "content-media-compositions": "static-2.17479",
  "media-bridge-lib": "static-1.19554",
  "chatspot-widget-iframe": "static-1.23484",
  "collaboration-sidebar-common": "static-1.3736",
  "marketing-platform-lib": "static-1.7305",
  "dnd-kit": "static-1.20",
  "card-properties-lib": "static-1.45215",
  "commerce-subscription-lib": "static-1.37989",
  "crm-actions": "static-1.6764",
  "crm-cards-sdk": "static-1.44871",
  "customer-data-properties-shared-msw-handlers": "static-1.10129",
  "customer-data-tracking": "static-1.7286",
  "calling-global-api": "static-1.66006",
  "calling-internal-common": "static-1.31736",
  "calling-lifecycle-internal": "static-1.67388",
  "calling-lifecycle-messages": "static-1.59681",
  "commerce-products-lib": "static-1.10757",
  "conditional-properties-service-client": "static-1.4082",
  "crm-index-visualization-core": "static-1.4675",
  "crm-links": "static-1.6716",
  "crm-pipelines-api-client-types": "static-1.4414",
  "formula-editor": "static-1.14930",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4491",
  "meetings-icalendar-utils-lib": "static-1.1050",
  "multi-currency-client-types": "static-1.3978",
  "object-builder-ui-client": "static-1.49909",
  "pipeline-validation-client-types": "static-1.4250",
  "smart-data-capture-core": "static-1.350",
  "smart-property-lib": "static-1.8520",
  "tiered-pricing": "static-1.2140",
  "topics-actions-lib": "static-1.588",
  "ui-addon-form-validation": "static-1.11338",
  "zustand": "static-1.88",
  "fdsr-migration-layer": "static-1.428",
  "framework-data-schema-quick-fetch": "static-1.7214",
  "restore-request-side-panel-lib": "static-1.1911",
  "growth-data-modal": "static-1.6047",
  "growth-onboarding-confetti": "static-1.3477",
  "growth-onboarding-next-action-utils": "static-1.2883",
  "onboarding-tours-utils": "static-1.1371",
  "ui-shepherd-tracker": "static-1.8068",
  "crm-index-associations-lib": "static-1.6861",
  "academy-service-client": "static-1.4106",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40236",
  "SafeStorage": "static-1.4808",
  "video-embed": "static-1.36818",
  "redux-actions": "static-3.73",
  "EmailSignatureEditor": "static-1.25154",
  "viral-links-lib": "static-1.7493",
  "nested-table": "static-1.650",
  "timezone-utils": "static-2.5644",
  "getting-started-shared-tasks-store": "static-1.18577",
  "campaign-roi-lib": "static-1.10648",
  "campaigns-utils-lib": "static-1.3647",
  "ui-addon-calendars": "static-2.5776",
  "customer-data-views-management": "static-1.26218",
  "framework-data-table": "static-2.12742",
  "nudge-custom-ui-functions": "static-1.1657",
  "switchboard-lib": "static-1.635",
  "access-check-ui-lib": "static-1.1785",
  "app-users-service-client": "static-1.6033",
  "app-users-service-types": "static-1.5441",
  "mini-checkout-client": "static-1.27740",
  "onboarding-utils": "static-1.5783",
  "permissions-shared-i18n-strings-fe": "static-1.2142",
  "ui-coaching-tips-shared-config": "static-1.29488",
  "checkout-sdk": "static-3.24583",
  "payment-method-components": "static-1.7260",
  "touchless-buying-components": "static-1.6451",
  "upgrade-catalog-service-types": "static-1.3840",
  "edison-service-client-types": "static-1.808",
  "growth-onboarding-feedback-components": "static-1.6997",
  "audio-components": "static-1.6488",
  "FileManagerImages": "static-1.37888",
  "video-components": "static-1.14328",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.93077",
  "customer-data-sidebar": "static-2.46920",
  "enrichment-lib": "static-1.782",
  "ui-addon-draggable-compat": "static-2.4676",
  "universal-record-utils-lib": "static-1.2235",
  "commerce-billing-lib": "static-1.20429",
  "commerce-shared-components-lib": "static-1.19472",
  "commerce-tools-ui-lib": "static-1.11226",
  "crm-fe-perf": "static-1.23309",
  "calling-error-reporting": "static-1.31743",
  "shared-worker-versioning": "static-1.11454",
  "calling-usage-tracker": "static-1.6949",
  "voice-sms-access-library": "static-1.2309",
  "commerce-permissions": "static-1.1190",
  "products-iframe-lib": "static-1.8794",
  "products-ui-components-shared-msw-handlers": "static-1.11184",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10885",
  "sales-views-client-types": "static-1.4672",
  "bark-lib": "static-1.16943",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.800",
  "policy-lib": "static-1.7219",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10948",
  "onboarding-data-sync-lib": "static-1.2740",
  "growth-onboarding-next-action-components": "static-1.2911",
  "user-context-client": "static-1.4922",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4929",
  "outpost": "static-1.4548",
  "draft-convert": "static-2.83",
  "draft-extend": "static-3.87",
  "draft-js": "static-5.89",
  "draft-plugins": "static-2.22270",
  "sales-email-signature-service-client": "static-1.4262",
  "ts-utils-lib": "static-1.562",
  "copilot-messaging": "static-1.2291",
  "crm-export-dialog": "static-1.6692",
  "crm-index-ui-shimmer": "static-1.2879",
  "crm-view-components": "static-1.1399",
  "react-beautiful-dnd": "static-1.74",
  "customer-data-associations": "static-1.7745",
  "tasks-actions-lib": "static-1.332",
  "InboxConnectUtils": "static-4.15745",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.47043",
  "hub-http-rxjs": "static-1.865",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4405",
  "company-details-components": "static-1.6620",
  "react-performance-metrics-lib": "static-1.968",
  "pricing-pages-ui-components": "static-1.16314",
  "quote-checkout-service-types": "static-1.3872",
  "social-insights-client-types": "static-1.22831",
  "crm_universal": "static-1.22636",
  "customer-data-email": "static-1.18589",
  "card-payment-highlight-lib": "static-1.38202",
  "commerce-contract-lib": "static-1.13642",
  "invoices-highlight-card-lib": "static-1.56047",
  "orders-highlight-card-lib": "static-1.22395",
  "products-highlight-card-lib": "static-1.19040",
  "quotes-highlight-card-lib": "static-1.72986",
  "crm-source-interpretation-lib": "static-1.5743",
  "data-agent-test-utils": "static-1.344",
  "data-agent-utils": "static-1.813",
  "enrichment-settings-lib": "static-1.127",
  "crm-object-search-query-utilities": "static-1.10370",
  "utility-belt": "static-1.2948",
  "payments-enrollment-embed-lib": "static-1.24092",
  "stripe-embedded-components": "static-1.8150",
  "customer-data-rte": "static-1.33805",
  "cv-backend-services": "static-1.1603",
  "growth-onboarding-empty-states": "static-1.6442",
  "payments-post-enroll-local-storage-lib": "static-1.5517",
  "qrcode-generator": "static-1.79",
  "quotes-client-types": "static-1.39076",
  "calling-orchestration-schema": "static-1.37086",
  "react-reducer-toolkit": "static-1.16564",
  "meetings-connect-utils-lib": "static-1.8029",
  "hub-http-contrib": "static-1.3440",
  "ui-addon-sales-email": "static-1.5617",
  "access-control-lib": "static-1.10842",
  "EmailComponents": "static-1.55742",
  "EmailData": "static-1.54420",
  "messaging-base-table-lib": "static-1.701",
  "redux-less": "static-2.9875",
  "company-details-service-types": "static-1.4357",
  "segments-query-core": "static-1.1842",
  "pricing-pages-api": "static-1.16179",
  "sequences-lib": "static-1.8683",
  "ui-gdpr-components": "static-1.10649",
  "products-ui-components": "static-1.41275",
  "reporting-enablement": "static-1.24052",
  "accounting-integrations-ui-components": "static-1.7710",
  "invoices-ui-lib": "static-1.56063",
  "commerce-products-api": "static-1.2835",
  "invoices-iframe-lib": "static-1.58121",
  "quotes-modal-lib": "static-1.103664",
  "quotes-ui-lib": "static-1.81707",
  "stripe-connect-js": "static-1.81",
  "draft-content-plugins": "static-1.29061",
  "ContentComponents": "static-2.72295",
  "ContentData": "static-1.69414",
  "marketing-email-service-types": "static-1.2177",
  "messaging-editing-lib": "static-1.47358",
  "messaging-usage-based-billing-components-lib": "static-1.2220",
  "automation-ui-source-apps": "static-1.19874",
  "automation-ui-types": "static-1.20792",
  "messaging-types-lib": "static-1.47095",
  "onboarding-settings-client": "static-1.4922",
  "sequences-client-types-lib": "static-1.8540",
  "commerce-tax-lib": "static-1.951",
  "price-books-api": "static-1.1922",
  "price-books-components": "static-1.1980",
  "property-description-translator": "static-1.4235",
  "ramp-editor": "static-1.1074",
  "data-quality-ui-library": "static-1.14168",
  "report-customization-components": "static-1.14104",
  "reporting-filters": "static-1.1193",
  "reporting-insights-lib": "static-1.2809",
  "commerce-analytics-service-client": "static-1.3931",
  "totals-ui-components": "static-1.24470",
  "SalesContentIndexUI": "static-3.9689",
  "advanced-menus-core": "static-1.15727",
  "advanced-menus-lib": "static-1.12512",
  "automation-ui-ubb": "static-1.6708",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7752",
  "data-token-views": "static-1.17023",
  "forms-utils-lib": "static-1.13247",
  "payments-embed-points-lib": "static-1.13756",
  "react-tinymce": "static-1.56167",
  "simple-menus-core": "static-1.15726",
  "simple-menus-lib": "static-1.17243",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55293",
  "tinymce-data": "static-1.41378",
  "tinymce-plugins": "static-1.58407",
  "tinymce-themes": "static-1.57263",
  "ui-brand-identity-lib": "static-1.16784",
  "ui-memberships-settings-lib": "static-1.35074",
  "videoconference-integration-components": "static-1.7443",
  "automation-applications-service-types": "static-1.3698",
  "automation-platform-service-types": "static-1.2709",
  "ContentEditorUI": "static-2.78125",
  "content-whatsapp-service-types": "static-1.639",
  "short-messages-app-service-client": "static-1.4337",
  "web-interactives-components": "static-1.14403",
  "web-interactives-data": "static-1.14404",
  "messaging-shared-utils-lib": "static-1.1669",
  "messaging-user-info-utils-lib": "static-1.1839",
  "email-portal-health-service-types": "static-1.1396",
  "line-items-api": "static-1.1243",
  "merge-modal-lib": "static-1.12924",
  "commerce-totals-service-types": "static-1.4100",
  "FireAlarmUi": "static-1.4801",
  "sales-templates-service-types-lib": "static-1.4452",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22728",
  "automation-ui-usage-tracking": "static-1.22191",
  "data-studio-ubb": "static-1.3709",
  "interframe": "static-3.5155",
  "layout-dnd-components": "static-1.13129",
  "layout-dnd-utils": "static-1.12104",
  "NamespacedHubStyle": "static-2.9326",
  "campaigns-lib": "static-1.27803",
  "content-management-data-lib": "static-1.6136",
  "copilot-plugins": "static-1.12013",
  "cta-picker": "static-1.37165",
  "customer-agent-discovery-components-lib": "static-1.4164",
  "editor-components": "static-1.13805",
  "editor-iframe-lib": "static-1.8928",
  "error-messaging-js": "static-1.5555",
  "FormsCommonComponents": "static-1.86743",
  "layout-data-lib": "static-1.10429",
  "pictos": "static-7.194",
  "react-transition-group": "static-2.77",
  "redux-request-state": "static-1.11052",
  "SharedLegalStrings": "static-1.2141",
  "smart-content-core": "static-1.43358",
  "smart-content-lib": "static-1.44011",
  "social-composer-lib": "static-1.60490",
  "structured-content-lib": "static-1.26097",
  "theme-previewer-lib": "static-1.54075",
  "tinymce-copilot": "static-1.17361",
  "xray-recommendation-lib": "static-1.8385",
  "automation-ui-routing": "static-1.22149",
  "sql-reporting-client-types": "static-1.5971",
  "attribution-lib": "static-1.42925",
  "voice-agents-components": "static-1.3977",
  "forms-ai-lib": "static-1.4900",
  "codemirror-dlb": "static-1.59684",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6859",
  "calling-orchestration-shared-library": "static-1.36861"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13413",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1019",
  "client-types": "/client-types/static-1.505",
  "data-fetching-client": "/data-fetching-client/static-1.10059",
  "foundations-components": "/foundations-components/static-1.8655",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1680",
  "foundations-theming": "/foundations-theming/static-1.4895",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.92",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8452",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10802",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11904",
  "I18n": "/I18n/static-7.1691",
  "jasmine-runner": "/jasmine-runner/static-1.6861",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.810",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13476",
  "quartz": "/quartz/static-1.7587",
  "react-dlb": "/react-dlb/static-1.92",
  "react-rhumb": "/react-rhumb/static-1-fix-undefined-routespec-crash.10",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3266",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11109",
  "reselect": "/reselect/static-3.15",
  "settings-ui-lib": "/settings-ui-lib/static-1.12942",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7767",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11560",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9943",
  "unified-auth": "/unified-auth/static-1.1131",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1413",
  "usage-tracker": "/usage-tracker/static-1.7727",
  "usage-tracker-core": "/usage-tracker-core/static-1.7577",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8464",
  "hub-http": "/hub-http/static-1.6623",
  "integrations-lib": "/integrations-lib/static-1.17295",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20952",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.938",
  "property-management-iframe": "/property-management-iframe/static-1.14345",
  "quartz-config": "/quartz-config/static-1.1365",
  "quartz-core": "/quartz-core/static-1.6806",
  "quartz-routing": "/quartz-routing/static-1.1017",
  "quick-fetch": "/quick-fetch/static-1.4191",
  "react": "/react/static-7.202",
  "rpc-client-utils": "/rpc-client-utils/static-1.5082",
  "ts-schema": "/ts-schema/static-1.4360",
  "ui-universal-auth": "/ui-universal-auth/static-1.9617",
  "UIComponents": "/UIComponents/static-3.8850",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3864",
  "quartz-webpack": "/quartz-webpack/static-1.3811",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.665",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9920",
  "codemirror": "/codemirror/static-5.105",
  "foundations-assets": "/foundations-assets/static-1.5300",
  "pulse": "/pulse/static-1.1052",
  "react-codemirror": "/react-codemirror/static-1.11053",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.818",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4924",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2611",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-story-utils": "/hs-story-utils/static-1.9839",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.88",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5622",
  "react-virtualized": "/react-virtualized/static-2.111",
  "StyleGuideUI": "/StyleGuideUI/static-3.512",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2941",
  "ui-fonts": "/ui-fonts/static-1.1166",
  "ui-images": "/ui-images/static-2.1269",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3378",
  "foundations-theming-base": "/foundations-theming-base/static-1.3880",
  "stylex": "/stylex/static-1.45",
  "HeadJS": "/HeadJS/static-2.811",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3563",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.17",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4722",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ai-rendering-library": "/ai-rendering-library/static-1.11300",
  "chirp-fetch": "/chirp-fetch/static-1.2313",
  "connections-embed-lib": "/connections-embed-lib/static-1.1661",
  "copilot-toolkit": "/copilot-toolkit/static-1.12041",
  "feedback-loader": "/feedback-loader/static-1.29972",
  "laboratory-lib": "/laboratory-lib/static-3.7564",
  "marketplace-embed": "/marketplace-embed/static-1.23099",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10847",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20907",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15122",
  "sanitize-text": "/sanitize-text/static-1.8571",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6141",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5413",
  "wootric-nps": "/wootric-nps/static-1.7263",
  "quartz-head": "/quartz-head/static-1.1252",
  "web-vitals": "/web-vitals/static-1.18",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5019",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4556",
  "highcharts": "/highcharts/static-8.114",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2778",
  "reporting-data": "/reporting-data/static-1.69176",
  "cssUtils": "/cssUtils/static-1.1034",
  "flux-actions": "/flux-actions/static-1.378",
  "react-colorpicker": "/react-colorpicker/static-2.10626",
  "react-dnd-compat": "/react-dnd-compat/static-1.5025",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10784",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7717",
  "icons": "/icons/static-2.699",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19484",
  "storybook-react": "/storybook-react/static-1.43",
  "trellis-story-utils": "/trellis-story-utils/static-1.4921",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6138",
  "quartz-i18n": "/quartz-i18n/static-1.1262",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.661",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1759",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.181",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1226",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.389",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.758",
  "slack-ui-library": "/slack-ui-library/static-1.10811",
  "fsm": "/fsm/static-1.4167",
  "customer-data-objects": "/customer-data-objects/static-1.8106",
  "property-translator": "/property-translator/static-1.5794",
  "hs-locale-management": "/hs-locale-management/static-1.361",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8332",
  "hs-promise-utils": "/hs-promise-utils/static-1.6003",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5288",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14711",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6024",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8176",
  "sanitize": "/sanitize/static-1.4885",
  "superstore": "/superstore/static-1.5172",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10687",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8488",
  "hub-http-janus": "/hub-http-janus/static-1.896",
  "hubspotter-http": "/hubspotter-http/static-1.4927",
  "immutable-less": "/immutable-less/static-1.5064",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18359",
  "nav-meta": "/nav-meta/static-1.30692",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18508",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1421",
  "ai-studio-lib": "/ai-studio-lib/static-1.12642",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19175",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.634",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9492",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8388",
  "ui-product-approvals": "/ui-product-approvals/static-1.29526",
  "ui-tool-access": "/ui-tool-access/static-1.10569",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4109",
  "property-management-common": "/property-management-common/static-1.6633",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1-aeastham-default-document-load-user-interaction.4",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.593",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1-aeastham-default-document-load-user-interaction.4",
  "quartz-auth": "/quartz-auth/static-1.1262",
  "quartz-test": "/quartz-test/static-1.1262",
  "quartz-tracking": "/quartz-tracking/static-1.966",
  "trellis-components": "/trellis-components/static-1.2960",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.492",
  "HubStyle": "/HubStyle/static-2.12211",
  "bender-build-tools": "/bender-build-tools/static-1.3513",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.114",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23493",
  "ContentUtils": "/ContentUtils/static-1.69339",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13443",
  "sassPrefix": "/sassPrefix/static-1.302",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.555",
  "batch-promise": "/batch-promise/static-1.1959",
  "event-emitter": "/event-emitter/static-1.1373",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5850",
  "magpie-types": "/magpie-types/static-1.5310",
  "stylex-utils": "/stylex-utils/static-1.158",
  "trellis-theming": "/trellis-theming/static-1.1394",
  "avatar-components": "/avatar-components/static-1.2897",
  "breeze-engine-core": "/breeze-engine-core/static-1.1281",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.952",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41211",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13580",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.180",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15830",
  "ExportDialog": "/ExportDialog/static-6.10787",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.377",
  "highlight.js": "/highlight.js/static-1.89",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.802",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42259",
  "reporting-snowflake": "/reporting-snowflake/static-1.57792",
  "reporting-ui-components": "/reporting-ui-components/static-2.66445",
  "reporting-visualizations": "/reporting-visualizations/static-1.61250",
  "trial-components-library": "/trial-components-library/static-1.14293",
  "ui-addon-teams": "/ui-addon-teams/static-1.21968",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.650",
  "navigation-components": "/navigation-components/static-1.19055",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2003",
  "simple-logging-lib": "/simple-logging-lib/static-1.3466",
  "nudge-client-utils": "/nudge-client-utils/static-1.3313",
  "fail-safe": "/fail-safe/static-1.366",
  "app-governance-lib": "/app-governance-lib/static-1.2581",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10951",
  "purchase-motions-components": "/purchase-motions-components/static-1.6557",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10622",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6144",
  "usage-tracker-public": "/usage-tracker-public/static-1.7538",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3741",
  "persist-promise": "/persist-promise/static-1.4116",
  "reference-resolvers": "/reference-resolvers/static-1.8594",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4330",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.747",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3424",
  "final-form": "/final-form/static-1.82",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "simple-data-table": "/simple-data-table/static-1.3719",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "onboarding-scopes": "/onboarding-scopes/static-1.6865",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5159",
  "content-assistance-lib": "/content-assistance-lib/static-1.8340",
  "content-media-capture": "/content-media-capture/static-1.5668",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10245",
  "emoji-mart": "/emoji-mart/static-3.6",
  "file-manager-components": "/file-manager-components/static-1.24737",
  "growth-payments-core": "/growth-payments-core/static-1.26392",
  "knowledge-content-types": "/knowledge-content-types/static-1.8699",
  "PatternValidationJS": "/PatternValidationJS/static-1.3301",
  "payment-link-components": "/payment-link-components/static-1.24332",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20467",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10281",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9508",
  "video-components-external": "/video-components-external/static-1.12326",
  "video-data-lib": "/video-data-lib/static-1.35984",
  "navigation-messaging": "/navigation-messaging/static-1.8382",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58939",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.453",
  "crm-component-utils": "/crm-component-utils/static-1.40054",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6302",
  "customer-data-properties": "/customer-data-properties/static-1.52877",
  "external-options-client-types": "/external-options-client-types/static-1.4408",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7309",
  "property-value-citations": "/property-value-citations/static-1.3491",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8519",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10800",
  "base-ui": "/base-ui/static-1.26",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "cms-field-types": "/cms-field-types/static-1.5226",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "atom": "/atom/static-1.5491",
  "idb-keyval": "/idb-keyval/static-1.54",
  "reactive-lib": "/reactive-lib/static-1.1136",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.672",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19459",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1138",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-message-bus": "/crm-message-bus/static-1.43987",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23646",
  "events-data-lib": "/events-data-lib/static-1.661",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5126",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4289",
  "hs-resources": "/hs-resources/static-1.608",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1417",
  "onboarding-tours": "/onboarding-tours/static-1.17304",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14665",
  "segments-client-types": "/segments-client-types/static-1.11959",
  "academy-common-lib": "/academy-common-lib/static-1.15290",
  "dashboard-lib": "/dashboard-lib/static-1.83159",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19167",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9124",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11516",
  "user-context": "/user-context/static-1.5477",
  "reporting-plugins": "/reporting-plugins/static-1.10904",
  "reporting-reports": "/reporting-reports/static-1.68852",
  "hubs-service-types": "/hubs-service-types/static-1.1677",
  "purchase-motions-api": "/purchase-motions-api/static-1.6560",
  "salesImages": "/salesImages/static-1.672",
  "signup-constants": "/signup-constants/static-1.19835",
  "nest": "/nest/static-1.649",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.981",
  "ably": "/ably/static-2.2",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3070",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3389",
  "whisper-core-api": "/whisper-core-api/static-1.7531",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.317",
  "framework-listing-lib": "/framework-listing-lib/static-2.29702",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31643",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8473",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5519",
  "one-click-checkout": "/one-click-checkout/static-1.645",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7964",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15363",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10314",
  "redux-thunk": "/redux-thunk/static-2.83",
  "react-flip-move": "/react-flip-move/static-1.82",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29503",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13472",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4839",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3886",
  "seat-types-lib": "/seat-types-lib/static-1.937",
  "ui-addon-opt": "/ui-addon-opt/static-4.8794",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6778",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5496",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3943",
  "data-token-picker": "/data-token-picker/static-1.17042",
  "FileManagerLib": "/FileManagerLib/static-1.40377",
  "content-media-compositions": "/content-media-compositions/static-2.17479",
  "media-bridge-lib": "/media-bridge-lib/static-1.19554",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23484",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3736",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7305",
  "dnd-kit": "/dnd-kit/static-1.20",
  "card-properties-lib": "/card-properties-lib/static-1.45215",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37989",
  "crm-actions": "/crm-actions/static-1.6764",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44871",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10129",
  "customer-data-tracking": "/customer-data-tracking/static-1.7286",
  "calling-global-api": "/calling-global-api/static-1.66006",
  "calling-internal-common": "/calling-internal-common/static-1.31736",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67388",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59681",
  "commerce-products-lib": "/commerce-products-lib/static-1.10757",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4082",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4675",
  "crm-links": "/crm-links/static-1.6716",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4414",
  "formula-editor": "/formula-editor/static-1.14930",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4491",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1050",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3978",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49909",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4250",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.350",
  "smart-property-lib": "/smart-property-lib/static-1.8520",
  "tiered-pricing": "/tiered-pricing/static-1.2140",
  "topics-actions-lib": "/topics-actions-lib/static-1.588",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11338",
  "zustand": "/zustand/static-1.88",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.428",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7214",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1911",
  "growth-data-modal": "/growth-data-modal/static-1.6047",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3477",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2883",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1371",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8068",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6861",
  "academy-service-client": "/academy-service-client/static-1.4106",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40236",
  "SafeStorage": "/SafeStorage/static-1.4808",
  "video-embed": "/video-embed/static-1.36818",
  "redux-actions": "/redux-actions/static-3.73",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25154",
  "viral-links-lib": "/viral-links-lib/static-1.7493",
  "nested-table": "/nested-table/static-1.650",
  "timezone-utils": "/timezone-utils/static-2.5644",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18577",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10648",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3647",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5776",
  "customer-data-views-management": "/customer-data-views-management/static-1.26218",
  "framework-data-table": "/framework-data-table/static-2.12742",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1657",
  "switchboard-lib": "/switchboard-lib/static-1.635",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1785",
  "app-users-service-client": "/app-users-service-client/static-1.6033",
  "app-users-service-types": "/app-users-service-types/static-1.5441",
  "mini-checkout-client": "/mini-checkout-client/static-1.27740",
  "onboarding-utils": "/onboarding-utils/static-1.5783",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2142",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29488",
  "checkout-sdk": "/checkout-sdk/static-3.24583",
  "payment-method-components": "/payment-method-components/static-1.7260",
  "touchless-buying-components": "/touchless-buying-components/static-1.6451",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3840",
  "edison-service-client-types": "/edison-service-client-types/static-1.808",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6997",
  "audio-components": "/audio-components/static-1.6488",
  "FileManagerImages": "/FileManagerImages/static-1.37888",
  "video-components": "/video-components/static-1.14328",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.93077",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46920",
  "enrichment-lib": "/enrichment-lib/static-1.782",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4676",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2235",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20429",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19472",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11226",
  "crm-fe-perf": "/crm-fe-perf/static-1.23309",
  "calling-error-reporting": "/calling-error-reporting/static-1.31743",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11454",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6949",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2309",
  "commerce-permissions": "/commerce-permissions/static-1.1190",
  "products-iframe-lib": "/products-iframe-lib/static-1.8794",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11184",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10885",
  "sales-views-client-types": "/sales-views-client-types/static-1.4672",
  "bark-lib": "/bark-lib/static-1.16943",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.800",
  "policy-lib": "/policy-lib/static-1.7219",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10948",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2740",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2911",
  "user-context-client": "/user-context-client/static-1.4922",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4929",
  "outpost": "/outpost/static-1.4548",
  "draft-convert": "/draft-convert/static-2.83",
  "draft-extend": "/draft-extend/static-3.87",
  "draft-js": "/draft-js/static-5.89",
  "draft-plugins": "/draft-plugins/static-2.22270",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4262",
  "ts-utils-lib": "/ts-utils-lib/static-1.562",
  "copilot-messaging": "/copilot-messaging/static-1.2291",
  "crm-export-dialog": "/crm-export-dialog/static-1.6692",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2879",
  "crm-view-components": "/crm-view-components/static-1.1399",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.74",
  "customer-data-associations": "/customer-data-associations/static-1.7745",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.332",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15745",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.47043",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.865",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4405",
  "company-details-components": "/company-details-components/static-1.6620",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.968",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16314",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3872",
  "social-insights-client-types": "/social-insights-client-types/static-1.22831",
  "crm_universal": "/crm_universal/static-1.22636",
  "customer-data-email": "/customer-data-email/static-1.18589",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38202",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13642",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.56047",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22395",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.19040",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72986",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5743",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.344",
  "data-agent-utils": "/data-agent-utils/static-1.813",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.127",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10370",
  "utility-belt": "/utility-belt/static-1.2948",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24092",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8150",
  "customer-data-rte": "/customer-data-rte/static-1.33805",
  "cv-backend-services": "/cv-backend-services/static-1.1603",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6442",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5517",
  "qrcode-generator": "/qrcode-generator/static-1.79",
  "quotes-client-types": "/quotes-client-types/static-1.39076",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37086",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16564",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8029",
  "hub-http-contrib": "/hub-http-contrib/static-1.3440",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5617",
  "access-control-lib": "/access-control-lib/static-1.10842",
  "EmailComponents": "/EmailComponents/static-1.55742",
  "EmailData": "/EmailData/static-1.54420",
  "messaging-base-table-lib": "/messaging-base-table-lib/static-1.701",
  "redux-less": "/redux-less/static-2.9875",
  "company-details-service-types": "/company-details-service-types/static-1.4357",
  "segments-query-core": "/segments-query-core/static-1.1842",
  "pricing-pages-api": "/pricing-pages-api/static-1.16179",
  "sequences-lib": "/sequences-lib/static-1.8683",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10649",
  "products-ui-components": "/products-ui-components/static-1.41275",
  "reporting-enablement": "/reporting-enablement/static-1.24052",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7710",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.56063",
  "commerce-products-api": "/commerce-products-api/static-1.2835",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.58121",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103664",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81707",
  "stripe-connect-js": "/stripe-connect-js/static-1.81",
  "draft-content-plugins": "/draft-content-plugins/static-1.29061",
  "ContentComponents": "/ContentComponents/static-2.72295",
  "ContentData": "/ContentData/static-1.69414",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2177",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47358",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2220",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19874",
  "automation-ui-types": "/automation-ui-types/static-1.20792",
  "messaging-types-lib": "/messaging-types-lib/static-1.47095",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4922",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8540",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.951",
  "price-books-api": "/price-books-api/static-1.1922",
  "price-books-components": "/price-books-components/static-1.1980",
  "property-description-translator": "/property-description-translator/static-1.4235",
  "ramp-editor": "/ramp-editor/static-1.1074",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.14168",
  "report-customization-components": "/report-customization-components/static-1.14104",
  "reporting-filters": "/reporting-filters/static-1.1193",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2809",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3931",
  "totals-ui-components": "/totals-ui-components/static-1.24470",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9689",
  "advanced-menus-core": "/advanced-menus-core/static-1.15727",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12512",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6708",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7752",
  "data-token-views": "/data-token-views/static-1.17023",
  "forms-utils-lib": "/forms-utils-lib/static-1.13247",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13756",
  "react-tinymce": "/react-tinymce/static-1.56167",
  "simple-menus-core": "/simple-menus-core/static-1.15726",
  "simple-menus-lib": "/simple-menus-lib/static-1.17243",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55293",
  "tinymce-data": "/tinymce-data/static-1.41378",
  "tinymce-plugins": "/tinymce-plugins/static-1.58407",
  "tinymce-themes": "/tinymce-themes/static-1.57263",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16784",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35074",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7443",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3698",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2709",
  "ContentEditorUI": "/ContentEditorUI/static-2.78125",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.639",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4337",
  "web-interactives-components": "/web-interactives-components/static-1.14403",
  "web-interactives-data": "/web-interactives-data/static-1.14404",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1669",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1839",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1396",
  "line-items-api": "/line-items-api/static-1.1243",
  "merge-modal-lib": "/merge-modal-lib/static-1.12924",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4100",
  "FireAlarmUi": "/FireAlarmUi/static-1.4801",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4452",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22728",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22191",
  "data-studio-ubb": "/data-studio-ubb/static-1.3709",
  "interframe": "/interframe/static-3.5155",
  "layout-dnd-components": "/layout-dnd-components/static-1.13129",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12104",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9326",
  "campaigns-lib": "/campaigns-lib/static-1.27803",
  "content-management-data-lib": "/content-management-data-lib/static-1.6136",
  "copilot-plugins": "/copilot-plugins/static-1.12013",
  "cta-picker": "/cta-picker/static-1.37165",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4164",
  "editor-components": "/editor-components/static-1.13805",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8928",
  "error-messaging-js": "/error-messaging-js/static-1.5555",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86743",
  "layout-data-lib": "/layout-data-lib/static-1.10429",
  "pictos": "/pictos/static-7.194",
  "react-transition-group": "/react-transition-group/static-2.77",
  "redux-request-state": "/redux-request-state/static-1.11052",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2141",
  "smart-content-core": "/smart-content-core/static-1.43358",
  "smart-content-lib": "/smart-content-lib/static-1.44011",
  "social-composer-lib": "/social-composer-lib/static-1.60490",
  "structured-content-lib": "/structured-content-lib/static-1.26097",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.54075",
  "tinymce-copilot": "/tinymce-copilot/static-1.17361",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8385",
  "automation-ui-routing": "/automation-ui-routing/static-1.22149",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5971",
  "attribution-lib": "/attribution-lib/static-1.42925",
  "voice-agents-components": "/voice-agents-components/static-1.3977",
  "forms-ai-lib": "/forms-ai-lib/static-1.4900",
  "codemirror-dlb": "/codemirror-dlb/static-1.59684",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6859",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.36861"
}
};
